import { cn } from "@/utils";
import { useEffect, useState } from "react";

type AnimationPhase = "square" | "expanded" | "shrinking" | "shrunk";

const getContainerClassName = (phase: AnimationPhase) => {
  const baseClasses = "text-xs font-light text-white whitespace-nowrap transition-all duration-500 ease-in-out overflow-hidden relative";

  switch (phase) {
    case "square":
      return `${baseClasses} max-w-0 opacity-0`;
    case "expanded":
      return `${baseClasses} max-w-[200px] opacity-100`;
    case "shrinking":
      return `${baseClasses} max-w-[120px] opacity-100`;
    case "shrunk":
      return `${baseClasses} opacity-100`;
    default:
      return baseClasses;
  }
};

/**
 * Recording indicator component
 */
export const RecordingIndicator = () => {
  const [phase, setPhase] = useState<AnimationPhase>("square");

  useEffect(() => {
    // After 1 second, expand to show "Enregistrement en cours"
    const expandTimer = setTimeout(() => {
      setPhase("expanded");
    }, 1000);

    // After 2 more seconds (3 total), start shrinking
    const shrinkStartTimer = setTimeout(() => {
      setPhase("shrinking");
    }, 3000);

    // Change text after width transition has progressed (3.4s - 100ms into the 500ms transition)
    const shrinkTextTimer = setTimeout(() => {
      setPhase("shrunk");
    }, 3300);

    return () => {
      clearTimeout(expandTimer);
      clearTimeout(shrinkStartTimer);
      clearTimeout(shrinkTextTimer);
    };
  }, []);

  return (
    <div
      className="flex items-center rounded-md p-2 border border-white border-solid transition-all duration-500 ease-in-out overflow-hidden"
      aria-label="Enregistrement en cours"
    >
      <div className="size-4 bg-red-500 rounded-sm flex-shrink-0" />
      <div className={getContainerClassName(phase)}>
        {phase !== 'square' && (
          <div className="ml-2">
            <span className={cn('inline-block transition-opacity duration-300', {
              'opacity-100': phase !== 'shrunk',
              'opacity-0 absolute': phase === 'shrunk',
            })}>
              L'enregistrement a commencé
            </span>
            <span className={cn('inline-block transition-opacity duration-300', {
              'opacity-100': phase === 'shrunk',
              'opacity-0 absolute left-0 top-0': phase !== 'shrunk',
            })}>
              Enregistrement
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
